import { useSelector } from 'react-redux';

import { selectDownloadDocumentsApi } from '../services/selectors';

export const useDownloadApi = () => useSelector(selectDownloadDocumentsApi);
